<template>

  <div>
    <vs-prompt title="Motoristas" :active.sync="configuracaoPopUpMotoristas.exibirPopUpMotorista" v-if="configuracaoPopUpMotoristas.exibirPopUpMotorista"
        @cancel="fecharPopUpMotoristas" @accept="alterarMotorista" @close="fecharPopUpMotoristas"  :is-valid="isPopUpMotoristaValido"
        :acceptText="$t('Btn_OK')" :cancelText="$t('Btn_Fechar')">
        <PopUpMotoristas @selecionarMotorista="onSelecionarMotorista" 
          :tipoSelecao="configuracaoPopUpMotoristas.tipoSelecao" 
          :idVeiculo="configuracaoPopUpMotoristas.idVeiculoSelecionado"
          :mensagemExplicacao="configuracaoPopUpMotoristas.mensagemExplicacao"> 
        </PopUpMotoristas>
    </vs-prompt>
    <vx-card ref="filterCard" :title="$t('Filtros')" class="mb-2" :collapse-action="true" >

     <vs-row vs-type="flex" vs-justify="space-between">        
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t("TelaMensagemTeclado_lVeiculo")}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-w="3">          
            <v-select 
                label="placa"
                :filter="pesquisarVeiculo"
                :options="listaVeiculos" 
                :reduce="v => v.idVeiculo" 
                v-model="filtro.idVeiculo"                                   
                class="v-select w-full">
            <template #option="{  placa, modelo, labelVeiculo  }">
                <small><strong> {{modelo}} </strong>  
                <em> - {{placa}} </em> <em v-if="labelVeiculo">/ {{labelVeiculo}} </em></small>
            </template>
            <template #selected-option="{ placa, labelVeiculo  }">                          
                <small style="font-size:0.70vw">{{placa}} <em v-if="labelVeiculo">/ {{labelVeiculo}} </em></small>
            </template>
            <template #no-options="">
                {{ $t('NenhumVeiculoEncontrado') }}
            </template>
          </v-select>  
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t("TelaMensagemTeclado_lMotorista")}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">             
           <v-select 
                label="nome"       
                :filter="pesquisarMotorista"        
                :options="listaMotoristas"                 
                v-model="filtro.condutor"                                   
                class="v-select w-full">
            <template #option="{  nome, cpf, codigoChaveiro  }">
                <small><strong> {{nome}} </strong>  
                <em> - {{cpf}}</em> <em v-if="codigoChaveiro"> - {{codigoChaveiro}} </em></small>
            </template>
            <template #selected-option="{ nome  }">                          
                <small style="font-size:0.70vw">{{nome}} </small>
            </template>
            <template #no-options="">
                {{ $t('NenhumMotoristaEncontrado') }}
            </template>
          </v-select>  
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">      
          <v-select                   
                  :reduce="tipo => tipo.data" 
                  :options="listaOpcoesExclusaoLogica" 
                  v-model="filtro.exclusaoLogica"       
                  :clearable="false"
                  class="v-select w-full ml-2"></v-select>                   
        </vs-col>
     </vs-row>
     <vs-row vs-type="flex" vs-justify="space-between" class="mt-2">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t("Periodo")}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">                
          <flat-pickr v-model="filtro.dataInicio" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
          <label class="ml-2 mr-2 vs-input--label">à</label>
          <flat-pickr v-model="filtro.dataFim" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
        </vs-col>                              
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5">      
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="3">
          <vx-tooltip :text="$t('Pesquisa')">              
            <vs-button class="mr-2" radius color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>          
          </vx-tooltip>
          <vx-tooltip :text="$t('Novo')">              
            <vs-button class="mr-2" radius color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>          
          </vx-tooltip>
          <vx-tooltip text="Enviar mensagem para o teclado">              
            <vs-button class="mr-2" radius color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-send" @click="routeEnviarMensagem"></vs-button>  
          </vx-tooltip>
          <vx-tooltip text="Auditoria">              
            <vs-button class="mr-2" radius color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-clipboard" @click="routeAuditoria"></vs-button>  
          </vx-tooltip>
          <vx-tooltip text="Gerar contra-senha">              
            <vs-button class="mr-2" radius color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-lock" @click="routeGerarContraSenha"></vs-button>  
          </vx-tooltip>
          <vx-tooltip text="Exportar CSV">              
            <vs-button class="mr-2" radius color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV"></vs-button>          
          </vx-tooltip>
        </vs-col>    
     </vs-row>
    </vx-card>

    <vx-card>      
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :headerHeight="25"
        :rowHeight="25"
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"           
        :animateRows="false"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="true"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>
      <small v-if="dadosDaGrid.length">REGISTROS: {{dadosDaGrid.length}} </small>           
    </vx-card>     
  </div>

</template>

<script>
import axios from "@/axios.js"
import flatPickr from 'vue-flatpickr-component';
import { AgGridVue } from "ag-grid-vue"
import '@/assets/concept/scss/tabelaBasica.scss'
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

const URL_SERVLET = "/ComunicacaoViaTecladoRestServlet";
const NAME_ROUTE_EDIT = "configuracao-mensagem-teclado-edit";

export const CONSTANTE_OPCAO_EXCLUSAO_LOGICA_ARRAY = [	
	{label:"Ativas", data: 0},		
	{label:"Inativas", data: 1},		
	{label:"Todas", data:-1}		
];

export const valor235959 = (23*60*60+59*60+59)*1000;

export default {
  components: {
    AgGridVue,
    flatPickr
  },  
  data() {
    return {
      filtro: {idVeiculo: null, dataInicio: null, dataFim: null, exclusaoLogica: -1, condutor: null, paginaAtual: null},
      configuracaoGrid: { 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: "#", valueGetter: "node.rowIndex + 1", width: 30 },
            { headerName: 'VEÍCULO', valueGetter: function(params) { return params.data.veiculoDadosAdicionais + ' ' + params.data.veiculoPlaca} },
            { headerName: 'ORIGEM', field: 'origem' },                 
            { headerName: 'DATA/HORA', field: 'dataHoraFormatado' },                 
            { headerName: 'CÓDIGO', field: 'codigo' },                 
            { headerName: 'MENSAGEM', field: 'mensagem' },
            { headerName: 'LOCALIZAÇÃO', field: 'localizacaoMensagem' },            
            { headerName: 'STATUS', field: 'statusComandoDesc' },                 
            { headerName: 'EXCLUÍDO?', field: 'exclusaoLogica', valueGetter: function(params) { return (params.data.exclusaoLogica ? 'SIM' : '') } },                 
          ]
      },
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "U", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
      },
      dadosDaGrid: [],
      totalRegistros: 0,
      configuracaoPopUpMotoristas: {
        condutorOriginal: null, 
        exibirPopUpMotorista: false,
        motoristasDoPopUp: null,
        tipoSelecao: "single",
        idVeiculoSelecionado: null,
        mensagemExplicacao: ""
      },
      listaMotoristas :[]
    }
  },  
  computed: {
    listaVeiculos() {
        return this.$store.state.veiculos;
    },
    filterSectionHeight() {
      return 320;   
    },    
    paginationPageSize() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetPageSize()
      else return 20  
    },
    totalPages() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.configuracaoGrid.gridApi.paginationGoToPage(val - 1)
      }
    },
    isPopUpMotoristaValido() {
      return (this.configuracaoPopUpMotoristas.motoristasDoPopUp !== null && this.configuracaoPopUpMotoristas.motoristasDoPopUp.length > 0);
    },
    getNomeMotoristaSelecionado() {
      if (this.filtro.condutor != null) {
        return this.filtro.condutor.nome;
      }
      return "";
    }
  },
  methods: {   
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'MensagemTeclado.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    },
    pesquisarVeiculo(options, varTermoPesquisa) {
      
      varTermoPesquisa = varTermoPesquisa.toUpperCase();
      return options.filter(function (veiculo) {
              return (veiculo.marca.toUpperCase().indexOf(varTermoPesquisa) != -1  || veiculo.modelo.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              veiculo.placa.toUpperCase().indexOf(varTermoPesquisa) != -1 || veiculo.condutor.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              (veiculo.labelVeiculo && veiculo.labelVeiculo.toUpperCase().indexOf(varTermoPesquisa) != -1)
              ) ;
      })
    },
    pesquisarMotorista(options, varTermoPesquisa) {
      
      varTermoPesquisa = varTermoPesquisa.toUpperCase();
      return options.filter(function (motorista) {
              return (motorista.nome.toUpperCase().indexOf(varTermoPesquisa) != -1  || motorista.cpf.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              motorista.codigoChaveiro.toUpperCase().indexOf(varTermoPesquisa) != -1);
      })
    },
    limparFiltros() {
      this.filtro =  {idVeiculo: null, dataInicio: null, dataFim: null, exclusaoLogica: -1, condutor: null};
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = String(firstDay.getTime()/1000);
      this.filtro.dataFim = String(lastDay.getTime()/1000);      
    },
    fetchLista(filtro) {    
      this.$vs.loading();  
      const params = new URLSearchParams();      
      params.append('method', 'FindAll');
      params.append('orderDirection', 'ASC');
      params.append('orderField', 'dataHora');
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      
      if (filtro.idVeiculo) {
        params.append('filter', filtro.idVeiculo);
      }

      if (filtro.exclusaoLogica === 0) {
        params.append('exclusaoLogica', 'false');
      } else if (filtro.exclusaoLogica === 1) {
        params.append('exclusaoLogica', 'true');
      }

      if (filtro.dataInicio) {
        params.append('dataInicio', filtro.dataInicio*1000);
      }

      if (filtro.dataFim) {
        params.append('dataFim', filtro.dataFim*1000 + valor235959 );  
      }
      if (filtro.condutor) {
          params.append('idMotorista', filtro.condutor.id);  
      }

      axios.post(URL_SERVLET, params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              this.dadosDaGrid = response.data;        
              this.totalRegistros = this.dadosDaGrid.length;                   
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - Mensagem Teclado - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },       
    routeEnviarMensagem() {
      this.$router.push({
            name: 'configuracao-mensagem-teclado-enviar'            
      })
    },
    routeGerarContraSenha() {
      this.$router.push({
            name: 'configuracao-mensagem-teclado-contra-senha'            
      })
    },
    routeAuditoria() {
      this.$router.push({
            name: 'configuracao-mensagem-teclado-auditoria'            
      })
    },    
    fetchMotoristas() {      
          const params = new URLSearchParams();
          params.append('method', 'FindAll');
          params.append('orderDirection', 'ASC');
          params.append('outputFormat', 'JSON');                    
          params.append('idCliente', this.$store.state.AppActiveUser.id);
          params.append('motoristaAtivo', true); 
          
          axios.post("/MotoristasRestServlet", params, 
                  { credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
          .then((response) => {
              if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) { // Efetuar logoff                    
                  this.$router.push({ path: '/login' })
              } else {
                  this.listaMotoristas = response.data;                       
              }
          })
          .catch((error) => { 
              /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - " + error);
          })                  
    },
  },
  mounted() {
    this.fetchMotoristas();

    if (this.$store.getters.filtroMensagemTeclado) {      
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroMensagemTeclado));        
    }  else {
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = String(firstDay.getTime()/1000);
      this.filtro.dataFim = String(lastDay.getTime()/1000);
    }
    
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api        
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   
    this.fetchLista(this.filtro);    
  },
  created() {
    this.listaOpcoesExclusaoLogica = CONSTANTE_OPCAO_EXCLUSAO_LOGICA_ARRAY;
  },beforeDestroy() {    
    this.filtro.paginaAtual = this.currentPage;
    console.log("this.filtro.paginaAtual=" + this.filtro.paginaAtual);
    this.$store.dispatch('setarFiltro', {nomeTela: 'mensagens-teclado' , filtro: this.filtro});
  },
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 285px);
  }
</style>